import { dynamicApiSlice } from "../dynamicApi";

interface ShareFeedbackRequest {
  url: string;
  comment: string;
}

export const feedbackApiSlice = dynamicApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    shareFeedback: builder.mutation<void, ShareFeedbackRequest>({
      query: (body) => ({
        url: "feedback",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useShareFeedbackMutation } = feedbackApiSlice;
